import { AxiosResponse } from 'axios';

import Resolver from 'src/common/Resolver';
import useSponsorsStore from 'src/stores/sponsorsStore';
import SponsorsManager from './SponsorsManager';

const SponsorsManagerResolver = () => {
  const { fetchSponsors } = useSponsorsStore(s => s);

  const loadDependencies = () =>
    Promise.all([fetchSponsors()] as Array<Promise<void | AxiosResponse<unknown>>>);

  return <Resolver resolve={loadDependencies} successComponent={SponsorsManager} />;
};

export default SponsorsManagerResolver;
